import { render } from "./kefu.vue?vue&type=template&id=ee0826a8"
import script from "./kefu.vue?vue&type=script&lang=js"
export * from "./kefu.vue?vue&type=script&lang=js"

import "./kefu.vue?vue&type=style&index=0&id=ee0826a8&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__